import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
  hover?: boolean;
  color?: string;
  colorD?: string;
}

export const UserIcon: React.FC<IconProps> = ({
  width = '24px',
  height = '24px',
  hover,
  color = '#ffffff',
  colorD = '#2C3E50'
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <circle cx='9' cy='7' r='4' stroke='#037691' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M3 21V19C3 16.7909 4.79086 15 7 15H11C13.2091 15 15 16.7909 15 19V21'
        stroke='#037691'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 3.13C17.7699 3.58317 19.0078 5.178 19.0078 7.005C19.0078 8.83201 17.7699 10.4268 16 10.88'
        stroke='#037691'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21 21V19C20.9896 17.1846 19.7578 15.6039 18 15.15'
        stroke='#037691'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
